// src/services/authService.js
import { api, setAccessToken, getAccessToken, removeAccessToken } from "../Api";

const AUTH_STATE_KEY = "auth_state";

export const authService = {
  // Login-Funktion
  async login(username, password) {
    try {
      const response = await api.post("/authenticate", {
        username,
        password
      });
      
      const { tokens, username: userName } = response.data;
      setAccessToken(tokens.access_token);
      
      // Speichere zusätzliche Auth-Informationen
      const authState = { isLoggedIn: true, username: userName };
      localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(authState));
      
      return { success: true, username: userName };
    } catch (error) {
      console.error("Login failed:", error);
      return { success: false, error: error.response?.data?.error || "Login fehlgeschlagen" };
    }
  },
  
  // Logout-Funktion (zentralisiert)
  async logout() {
    try {
      // Optional: Backend-Logout-Endpunkt aufrufen
      await api.get("/logout").catch(() => {});
    } finally {
      // Lokalen State bereinigen
      removeAccessToken();
      localStorage.removeItem(AUTH_STATE_KEY);
    }
  },
  
  // Prüfen, ob Benutzer eingeloggt ist
  isAuthenticated() {
    const token = getAccessToken();
    const authState = this.getAuthState();
    return !!token && authState?.isLoggedIn === true;
  },
  
  // Auth-Status abrufen
  getAuthState() {
    try {
      const state = localStorage.getItem(AUTH_STATE_KEY);
      return state ? JSON.parse(state) : null;
    } catch (e) {
      return null;
    }
  },
  
  // Username abrufen
  getUsername() {
    const authState = this.getAuthState();
    return authState?.username || "";
  }
};